<div class="block w-full relative"
  [ngStyle]="{ padding: linePadding }">
    <div>
        <vsf-title-box
            [titleInfo]="titleInfo"
            [forComponent]="true">
        </vsf-title-box>
    </div>
    <div [innerHTML]="htmlContent"></div>
</div>